export function numberSpacing(str, n = 0) {
  str = stringifyNum(str, n);
  const comp = str.split(".");
  let isNegative = false;

  if (comp[0].length > 0 && comp[0][0] === "-") {
    comp[0] = comp[0].substring(1);
    isNegative = true;
  }

  let formattedInt = "";

  for (let i = comp[0].length - 1, count = 0; i >= 0; i--, count++) {
    if (count !== 0 && count % 3 === 0) {
      formattedInt = "\u00A0" + formattedInt;
    }

    formattedInt = comp[0][i] + formattedInt;
  }

  return (isNegative ? "-" : "") + formattedInt + (comp.length > 1 && comp[1].length > 0 ? "." + comp[1] : "");
}

function stringifyNum(num, n) {
  let str = typeof num === "string" ? num :
  /*(n <= 9007199254740992 ?*/
  num.toFixed(n)
  /*: num.toString())*/
  ;
  if (str.indexOf("e") === -1) return str; // get rid of scientific notation

  let [base, exponent] = str.split("e");
  base = base.split(".");
  let originalPeriodIndex = base[0].length;
  let parsedExp = parseInt(exponent);
  let newPeriodIndex = originalPeriodIndex + parsedExp;
  str = base.join("");
  let newInt = "";
  let newDec = "";

  if (newPeriodIndex < 0) {
    newDec = str;
    const diff = Math.abs(newPeriodIndex);

    for (let i = 0; i < diff; i++) {
      newDec = "0" + newDec;
    }

    newInt = "0";
  }

  if (newPeriodIndex > str.length) {
    newInt = str;
    const diff = newPeriodIndex - str.length;

    for (let i = 0; i < diff; i++) {
      newInt = newInt + "0";
    }

    newDec = "";
  } else {
    newInt = str.slice(0, newPeriodIndex);
    newDec = str.slice(newPeriodIndex);
  }

  if (newDec.length > n) {
    newDec = newDec.slice(0, n);
  } else if (newDec.length < n) {
    const diff = n - newDec.length;

    for (let i = 0; i < diff; i++) {
      newDec += "0";
    }
  }

  return newInt + (newDec.length > 0 ? "." + newDec : "");
}